"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePage = void 0;
var axios_1 = __importDefault(require("axios"));
var react_1 = require("react");
var react_router_1 = require("react-router");
var usePage = function () {
    var _a = (0, react_1.useState)(true), isPageLoading = _a[0], setIsPageLoading = _a[1];
    var _b = (0, react_1.useState)(null), pageData = _b[0], setPageData = _b[1];
    var params = (0, react_router_1.useParams)();
    var shopCode = params.shop_code ? params.shop_code : "main";
    var apiUrl = "/api/page/" + shopCode;
    apiUrl = params.path ? apiUrl + "?path=" + params.path : apiUrl;
    (0, react_1.useEffect)(function () {
        axios_1.default
            .get(apiUrl)
            .then(function (data) {
            setPageData(data.data);
        })
            .catch()
            .finally(function () {
            setIsPageLoading(false);
        });
    }, []);
    return { pageData: pageData, isPageLoading: isPageLoading };
};
exports.usePage = usePage;
